import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Leaf } from '@phosphor-icons/react';
import { API_URL } from '../config/api';

/**
 * NfcRedirectPage — `/nfc` lands here after a card tap.
 * Posts the tap (for logging) and then invisibly redirects to the admin-
 * configured destination. The visitor sees a sub-second TurfPulse splash.
 */
const NfcRedirectPage = () => {
  const [message, setMessage] = useState('Welcome — opening TurfPulse…');

  useEffect(() => {
    let cancelled = false;

    const go = async () => {
      try {
        const res = await axios.post(
          `${API_URL}/api/nfc/tap`,
          {},
          { withCredentials: false, timeout: 4000 },
        );
        const dest = res.data?.destination || '/try';
        if (cancelled) return;

        // If destination is absolute http(s), use href. If relative, navigate in-app.
        if (dest.startsWith('http://') || dest.startsWith('https://')) {
          window.location.replace(dest);
        } else {
          window.location.replace(dest);
        }
      } catch {
        if (!cancelled) {
          setMessage('Welcome — opening TurfPulse…');
          // Fallback: send to /hey if the tap log fails
          setTimeout(() => window.location.replace('/hey'), 800);
        }
      }
    };

    go();
    return () => { cancelled = true; };
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-background"
      data-testid="nfc-redirect-page"
    >
      <div className="text-center space-y-4 animate-pulse">
        <div className="w-14 h-14 mx-auto rounded-full bg-primary/10 flex items-center justify-center">
          <Leaf size={28} weight="fill" className="text-primary" />
        </div>
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-primary">TurfPulse</p>
          <p className="text-sm text-muted-foreground mt-1">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default NfcRedirectPage;
